/* @jsx h */
import { defineComponent, h } from "vue";

type ListRowsSkeletonProps = { rows?: number };

/** Placeholder for an icon + label/value grouped list (profile info). */
export const ListRowsSkeleton = defineComponent<ListRowsSkeletonProps>(
  (props) => {
    return () => (
      <div
        class="divide-y divide-base-content/5 overflow-hidden rounded-2xl bg-base-200/60"
        aria-hidden="true"
      >
        {Array.from({ length: props.rows ?? 4 }, (_, index) => (
          <div key={index} class="flex items-center gap-3 px-4 py-3.5">
            <div class="skeleton size-9 shrink-0 rounded-xl" />
            <div class="flex-1 space-y-1.5">
              <div class="skeleton h-3 w-20 rounded" />
              <div class="skeleton h-4 w-40 max-w-full rounded" />
            </div>
          </div>
        ))}
      </div>
    );
  },
  { props: ["rows"] },
);

type CardsSkeletonProps = { cards?: number };

/** Placeholder for a stack of cards (orders, addresses). */
export const CardsSkeleton = defineComponent<CardsSkeletonProps>(
  (props) => {
    return () => (
      <div class="space-y-4" aria-hidden="true">
        {Array.from({ length: props.cards ?? 3 }, (_, index) => (
          <div
            key={index}
            class="space-y-3 rounded-2xl bg-base-200/60 p-4"
          >
            <div class="flex items-center justify-between gap-3">
              <div class="skeleton h-4 w-32 rounded" />
              <div class="skeleton h-5 w-16 rounded-full" />
            </div>
            <div class="skeleton h-3 w-3/4 rounded" />
            <div class="skeleton h-3 w-1/2 rounded" />
          </div>
        ))}
      </div>
    );
  },
  { props: ["cards"] },
);
